// Common State.
const defaults = {
    title: '',
    layout: 'DefaultLayout',
    error: {
      code: null,
      level: null,
      message: ''
    }
  }
  
  // Global module loaded on first app load.
  export default {
    namespaced: true,
  
    state: Object.assign({}, defaults),
  
    mutations: {
      updateTitle (state, title) {
        state.title = title
      },
  
      updateLayout (state, layout) {
        state.layout = layout
      },
  
      error (state, options) {
        state.error = Object.assign({}, defaults.error, options)
      },
  
      clear (state) {
        state = Object.assign({}, defaults)
      }
    },
  
    actions: {
      clear ({ state, commit, rootState, dispatch }) {
        commit('clear')
        dispatch('auth/clear', {}, { root: true })
      },

      updateTitle ({ commit }, title) {
        commit('updateTitle', title)
      },

      updateLayout ({ commit }, layout) {
        commit('updateLayout', layout)
      }
    }
  }